import { render, staticRenderFns } from "./Examination.vue?vue&type=template&id=5f612499&scoped=true&"
import script from "./Examination.vue?vue&type=script&lang=js&"
export * from "./Examination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f612499",
  null
  
)

export default component.exports